import { render, staticRenderFns } from "./MyVerifyForm.vue?vue&type=template&id=28ab2ec3&scoped=true&"
import script from "./MyVerifyForm.vue?vue&type=script&lang=js&"
export * from "./MyVerifyForm.vue?vue&type=script&lang=js&"
import style0 from "./MyVerifyForm.vue?vue&type=style&index=0&id=28ab2ec3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ab2ec3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCol,VRow,VSlideYTransition})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
